import { NavigationGuard } from "vue-router";
import { jwtService } from "@/jwt";
import { RouterPathName } from "@/enums/router-path-name.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon session id guard.
 * It checks for falconSessionId in JWT token.
 */
export const falconGuard: NavigationGuard = (to, from, next) => {
  if (jwtService.payload.falconSessionId) {
    next();
  } else {
    next({
      name: RouterPathName.AppMain,
      query: {
        noFalconSession: JSON.stringify(true)
      }
    });
  }
};
